import {mapGetters, mapState} from "vuex";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import translateMixin from "@/components/mixins/translateMixin";
import {RedirectorOutgoingKeysEnum} from "@/core/constants/enums/redirector/redirectorKeysEnum";

function getLocalStorageItem(key) {
    if (this.isLocalStorageAvailable()) {
        return localStorage.getItem(key);
    }
    return null;
}

function getLocalStorageObject(key, keepExpired = false) {
    if (!this.isLocalStorageAvailable()) {
        return null;
    }

    const value = localStorage.getItem(key);

    if (!value) {
        return null;
    }

    let object = null;
    try {
        object = JSON.parse(value);
    } catch (e) {
        return null;
    }

    if (object.expiration && !keepExpired) {
        const expirationDate = this.moment(object.expiration);
        const currentDate = this.moment();
        const objectExpired = expirationDate.isBefore(currentDate);

        if (objectExpired) {
            localStorage.removeItem(key);
            return null;
        }
    }

    return object.value;
}

function setLocalStorageItem(key, value) {
    if (this.isLocalStorageAvailable()) {
        localStorage.setItem(key, value);
        return true;
    }
    return false;
}

function setLocalStorageObject(key, value, expiration = null) {
    const payload = {
        value,
        expiration,
    }

    return this.setLocalStorageItem(key, JSON.stringify(payload));
}

function isLocalStorageAvailable() {
    if (typeof localStorage === "undefined" || !localStorage) {
        return false;
    }

    try {
        const test = 'testKey123qweasd';
        localStorage.setItem(test, test);
        localStorage.getItem(test);
        localStorage.removeItem(test);

        return true;
    } catch (e) {
        return false;
    }
}

function deleteLocalStorageItem(key) {
    if (this.isLocalStorageAvailable()) {
        localStorage.removeItem(key);
        return true;
    }

    return false;
}

function pullLocalStorageItem(key) {
    const value = this.getLocalStorageItem(key)

    if (value) {
        this.deleteLocalStorageItem(key);
    }

    return value;
}

function pullLocalStorageObject(key) {
    const data = this.getLocalStorageObject(key);
    this.deleteLocalStorageItem(key);

    return data;
}

const data = () => ({
    store: $store,
    moment: moment,
    escortCallFeedbackKey: 'escortCallFeedback',
});

const paymentRedirectLinkKey = 'paymentRedirectLink';
const onboardingRedirectLinkKey = 'onboardingRedirectLink';

function setPaymentRedirectLink(link) {
    this.setLocalStorageObject(paymentRedirectLinkKey, link, this.moment().add(30, 'minutes').toISOString());
}

/**
 * @returns {null|string}
 */
function getPaymentRedirectLink() {
    let redirectLink = this.getLocalStorageObject(onboardingRedirectLinkKey);
    this.deleteLocalStorageItem(onboardingRedirectLinkKey)

    if (!redirectLink) {
        redirectLink = this.getLocalStorageObject(paymentRedirectLinkKey);
        this.deleteLocalStorageItem(paymentRedirectLinkKey)
    }

    let tipRedirectProfilePath = this.getTipProfileModalRedirector && this.getTipProfileModalRedirector.tipRedirectProfilePath
        ? regionRelativeUrl(this.getTipProfileModalRedirector.tipRedirectProfilePath)
        : null

    if (tipRedirectProfilePath) {
        tipRedirectProfilePath += `?${RedirectorOutgoingKeysEnum.CONFIRM_TIP_PURCHASE}=${this.getTipProfileModalRedirector.tipAmount}`
    }

    return redirectLink || tipRedirectProfilePath;
}

export default {
    data,
    mixins: [
        translateMixin,
    ],
    methods: {
        getLocalStorageItem,
        isLocalStorageAvailable,
        setLocalStorageItem,
        setLocalStorageObject,
        getLocalStorageObject,
        deleteLocalStorageItem,
        setPaymentRedirectLink,
        getPaymentRedirectLink,
        pullLocalStorageItem,
        pullLocalStorageObject,
    },
    computed: {
        ...mapState(['translate']),
        ...mapGetters(['getTipProfileModalRedirector']),
    }
}
